import { Injectable } from '@angular/core';
import { TutorialDataService } from './tutorial-data.service';
import { TutorialShared } from 'src/app/presentation/general/shared/tutorial-shared';
import {
  TutorialInputModel,
  TutorialDimentionsModel,
} from 'src/app/core/model/input/tutorial-input-model';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  type: string;

  constructor(
    private tutorialDataService: TutorialDataService,
    private tutorialShared: TutorialShared
  ) {}

  checkDietTutorial() {
    this.type = 'diet';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.diet) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.dietTutorial();
        }
      });
  }

  dietTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.cheatDayBox) {
          const positionInfo =
            this.tutorialShared.cheatDayBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              60 + window.innerHeight / 10,
              32,
              window.innerWidth - 64,
              100
            ),
            'در هر برنامه غذایی ۱ماهه، می‌توانید ۲ روز آزاد داشته‌باشید که از این قسمت انتخاب می‌شود.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        } else {
          this.checkPlanTutorial();
        }
        break;
      }
      case 2: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.diet = true;
            this.tutorialDataService.saveTutorial(res);
            this.checkPlanTutorial();
          }
        });
        break;
      }
    }
  }

  checkNoDietTutorial() {
    this.type = 'noDiet';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.noDiet) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.noDietTutorial();
        } else {
          this.checkPlanTutorial();
        }
      });
  }

  noDietTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.noDietBox) {
          const positionInfo =
            this.tutorialShared.noDietBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              210 + window.innerHeight / 10,
              32,
              window.innerWidth - 64,
              100
            ),
            'می‌‌توانید همین حالا برای دریافت برنامه غذایی شخصی خود اقدام کنید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 2: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.noDiet = true;
            this.tutorialDataService.saveTutorial(res);
            this.checkPlanTutorial();
          }
        });
        break;
      }
    }
  }

  checkPlanTutorial() {
    this.type = 'plan';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.plan) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.planTutorial();
        }
      });
  }

  planTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.calendarBox) {
          const positionInfo =
            this.tutorialShared.calendarBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top + 8,
              window.innerWidth - positionInfo.right + 8,
              positionInfo.width - 16,
              positionInfo.height - 16
            ),
            new TutorialDimentionsModel(
              120 + window.innerHeight / 5,
              32,
              window.innerWidth - 64,
              100
            ),
            'برای دسترسی به برنامه روزهای بعد، از تقویم استفاده کنید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 2: {
        if (this.tutorialShared.calorieChartBox) {
          const positionInfo =
            this.tutorialShared.calorieChartBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              300 + window.innerHeight / 5,
              32,
              window.innerWidth - 64,
              100
            ),
            'این نمودار میزان کالری مصرفی روزانه شما را نشان می‌دهد.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 3: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.plan = true;
            this.tutorialDataService.saveTutorial(res);
          }
        });
        break;
      }
    }
  }

  checkProfileTutorial() {
    this.type = 'profile';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.profile) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.profileTutorial();
        }
      });
  }

  profileTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.settingBox) {
          const positionInfo =
            this.tutorialShared.settingBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              64 + window.innerHeight / 10,
              32,
              window.innerWidth - 64,
              100
            ),
            'اگر می‌خواهید به تنظیمات شخصی و برنامه دسترسی پیدا کنید، از این قسمت استفاده نمایید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 2: {
        if (this.tutorialShared.reportsBox) {
          const positionInfo =
            this.tutorialShared.reportsBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(64, 32, window.innerWidth - 64, 100),
            'می‌توانید نمودارهای مربوط به کالری، آب و وزن خود را در این قسمت مشاهده نمایید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 3: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.profile = true;
            this.tutorialDataService.saveTutorial(res);
          }
        });
        break;
      }
    }
  }

  checkSuggestedPackageTutorial() {
    this.type = 'suggestedPackage';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.suggestedPackage) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.suggestedPackageTutorial();
        } else {
          this.checkHasFoodTutorial();
        }
      });
  }

  suggestedPackageTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.packageBox) {
          const positionInfo =
            this.tutorialShared.packageBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              window.innerHeight - 100,
              32,
              window.innerWidth - 64,
              100
            ),
            'این کارت پکیج پیشنهادی بنتو برای این وعده را نشان می‌دهد.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        } else {
          this.checkHasFoodTutorial();
        }
        break;
      }
      case 2: {
        if (this.tutorialShared.changeMealBox) {
          const positionInfo =
            this.tutorialShared.changeMealBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              window.innerHeight - 100,
              32,
              window.innerWidth - 64,
              100
            ),
            'در این قسمت می‌توانید از میان پکیج‌های غذایی پیشنهادی ما، پکیج مورد نظر خود را جست‌و‌جو و انتخاب کنید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 3: {
        if (this.tutorialShared.consumeMealBox) {
          const positionInfo =
            this.tutorialShared.consumeMealBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              window.innerHeight - 100,
              32,
              window.innerWidth - 64,
              100
            ),
            'با انتخاب این دکمه، می‌توانید غذاهای پکیج را به لیست غذاهای ثبت‌شده اضافه کنید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 4: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.suggestedPackage = true;
            this.tutorialDataService.saveTutorial(res);
            this.checkHasFoodTutorial();
          }
        });
        break;
      }
    }
  }

  checkHasFoodTutorial() {
    this.type = 'hasFood';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.hasFood) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.hasFoodTutorial();
        } else {
          this.checkAddFoodTutorial();
        }
      });
  }

  hasFoodTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.foodBox) {
          const positionInfo =
            this.tutorialShared.foodBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(
              200 + window.innerHeight / 10,
              32,
              window.innerWidth - 64,
              100
            ),
            'با انتخاب هر کدام از موارد پکیج غذایی می‌توانید مقدار آن را تغییر دهید یا آن را حذف نمایید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        } else {
          this.checkAddFoodTutorial();
        }
        break;
      }
      case 2: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.hasFood = true;
            this.tutorialDataService.saveTutorial(res);
            this.checkAddFoodTutorial();
          }
        });
        break;
      }
    }
  }

  checkAddFoodTutorial() {
    this.type = 'addFood';
    this.tutorialDataService
      .getTutorial()
      .then((res): boolean => {
        if (res) {
          if (res.addFood) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
      .then((needTutorial) => {
        if (needTutorial) {
          this.tutorialShared.tutorialStep = 1;
          this.addFoodTutorial();
        }
      });
  }

  addFoodTutorial() {
    switch (this.tutorialShared.tutorialStep) {
      case 1: {
        if (this.tutorialShared.addFoodBox) {
          const positionInfo =
            this.tutorialShared.addFoodBox.getBoundingClientRect();
          this.tutorialShared.selectedTutorial = new TutorialInputModel(
            new TutorialDimentionsModel(
              positionInfo.top,
              window.innerWidth - positionInfo.right,
              positionInfo.width,
              positionInfo.height
            ),
            new TutorialDimentionsModel(56, 32, window.innerWidth - 64, 100),
            'می‌توانید با جست‌و‌جوی غذای مورد نظرتان، آن را به برنامه این وعده اضافه کنید.'
          );

          this.tutorialShared.showTutorial();
          this.tutorialShared.tutorialStep++;
        }
        break;
      }
      case 2: {
        this.tutorialDataService.getTutorial().then((res) => {
          if (res) {
            res.addFood = true;
            this.tutorialDataService.saveTutorial(res);
          }
        });
        break;
      }
    }
  }

  dismiss() {
    this.tutorialShared.hideTutorial();
    setTimeout(() => {
      if (this.type === 'diet') {
        this.dietTutorial();
      } else if (this.type === 'noDiet') {
        this.noDietTutorial();
      } else if (this.type === 'profile') {
        this.profileTutorial();
      } else if (this.type === 'suggestedPackage') {
        this.suggestedPackageTutorial();
      } else if (this.type === 'hasFood') {
        this.hasFoodTutorial();
      } else if (this.type === 'addFood') {
        this.addFoodTutorial();
      } else if (this.type === 'plan') {
        this.planTutorial();
      }
    }, 100);
  }
}
